import api from './api'

// Типы
export interface Booking {
  id: string
  slot: {
    id?: string
    date: string
    start_time: string
    end_time: string
  }
  trainer?: {
    id: string
    name: string
  }
  trainer_name?: string
  client?: {
    id: string
    name: string
    username?: string
  } | null
  status: 'confirmed' | 'cancelled' | 'completed' | 'no_show'
  pair_status?: 'accepted' | 'cancelled'
  pair_partner_name?: string
  guest_details?: string | null
  notes?: string
  created_at?: string
}

// API для клиентов
export async function getMyBookings(status?: string) {
  const params: Record<string, string> = {}
  if (status) params.status = status

  const response = await api.get<{ bookings: Booking[] }>('/bookings/me', { params })
  return response.data.bookings
}

export async function getUpcomingBookings() {
  const response = await api.get<{ bookings: Booking[] }>('/bookings/me/upcoming')
  return response.data.bookings
}

export async function getPastBookings() {
  const response = await api.get<{ bookings: Booking[] }>('/bookings/me/past')
  return response.data.bookings
}

export async function createBooking(slotId: string, notes?: string) {
  const response = await api.post<{
    message: string
    booking: Booking
  }>('/bookings', {
    slot_id: slotId,
    notes,
  })
  return response.data
}

export async function cancelBooking(bookingId: string, reason?: string) {
  const response = await api.post<{ message: string }>(`/bookings/${bookingId}/cancel`, {
    reason,
  })
  return response.data
}

// API для тренеров
export async function getTrainerBookings(dateFrom?: string, dateTo?: string) {
  const params: Record<string, string> = {}
  if (dateFrom) params.date_from = dateFrom
  if (dateTo) params.date_to = dateTo

  const response = await api.get<{ bookings: Booking[] }>('/bookings/trainer/all', { params })
  return response.data.bookings
}

export async function trainerCancelBooking(bookingId: string, reason?: string) {
  const response = await api.post<{ message: string }>(`/bookings/trainer/${bookingId}/cancel`, {
    reason,
  })
  return response.data
}

export async function completeBooking(bookingId: string) {
  const response = await api.post<{ message: string }>(`/bookings/trainer/${bookingId}/complete`)
  return response.data
}

// Отправить .ics файл в Telegram для добавления в календарь
export async function sendCalendarToTelegram(bookingId: string) {
  const response = await api.post<{ message: string }>(`/bookings/${bookingId}/send-calendar`)
  return response.data
}

export async function createGuestBooking(slotId: string, guestDetails: string) {
  return (await api.post('/bookings/trainer/guests', { slot_id: slotId, guest_details: guestDetails })).data
}

export async function updateGuestBooking(bookingId: string, guestDetails: string) {
  return (await api.patch(`/bookings/trainer/guests/${bookingId}`, { guest_details: guestDetails })).data
}
